import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Flex, IconButton, Text } from '@radix-ui/themes';
import { JobCategoriesGroupModel } from './job-categories-group.model';
import { useTranslation } from 'react-i18next';
import { AddIcon, ClearIcon } from 'shared/icons';
import { JobCategoryGroup } from './job-category-group';

function JobCategoriesGroupView({ viewModel }: { viewModel: JobCategoriesGroupModel }) {
   const { t } = useTranslation('global');
   React.useEffect(() => {
      return () => viewModel.dispose();
   }, [viewModel]);
   return (
      <Flex className="categories-group" direction="column" gap="3">
         <JobCategoryGroup
            model={viewModel.categoryModel}
            required
            categoryError={viewModel.jobManager.form.controls['category'].error}
            subCategoryError={viewModel.jobManager.form.controls['subCategory'].error}
            categories={viewModel.categories}
            actions={
               <Button
                  size="3"
                  className="add-messenger-trigger"
                  variant="outline"
                  type="button"
                  onClick={() => viewModel.onAdd()}
               >
                  <Text weight="regular" wrap="nowrap">
                     Додати ще
                  </Text>
                  <AddIcon />
               </Button>
            }
         />

         <JobCategoryGroup
            model={viewModel.categoryModel1}
            categories={viewModel.categories}
            actions={
               <IconButton
                  size="3"
                  type="button"
                  variant="outline"
                  onClick={() => viewModel.categoryModel1.hide()}
               >
                  <ClearIcon />
               </IconButton>
            }
         />

         <JobCategoryGroup
            model={viewModel.categoryModel2}
            categories={viewModel.categories}
            actions={
               <IconButton
                  size="3"
                  type="button"
                  variant="outline"
                  onClick={() => viewModel.categoryModel2.hide()}
               >
                  <ClearIcon />
               </IconButton>
            }
         />
      </Flex>
   );
}

export const JobCategoriesGroup = observer(JobCategoriesGroupView);
